/**
 * Translation dictionaries for the HaBallerim app.
 * Keys are dot-paths resolved by useTranslation().t(key).
 */
export const translations = {
  en: {
    brand: {
      name: 'HaBallerim  🪖',
      tagline: 'Wear the Game',
    },
    nav: {
      shop: 'Shop',
      teams: 'Teams',
      customKits: 'Custom Kits',
      dashboard: 'Dashboard',
      signIn: 'Sign In',
      signOut: 'Sign Out',
      adminDashboard: 'Admin Dashboard',
      cartAria: 'Shopping cart, {count} item',
      cartAriaPlural: 'Shopping cart, {count} items',
      userMenu: 'User menu',
      toggleMenu: 'Toggle navigation menu',
      home: 'Home',
      language: 'Language',
      languageEnglish: 'English',
      languageHebrew: 'עברית',
    },
    footer: {
      rights: '© {year} {brand} Soccer Store. All rights reserved.',
      company: 'Company',
      support: 'Support',
      newsletter: 'Newsletter',
      newsletterCopy: 'Get the latest kits & offers in your inbox.',
      newsletterPlaceholder: 'you@email.com',
      newsletterSubmit: 'Join',
      emailLabel: 'Email address',
      tagline: 'Official Licensed Soccer Merchandise',
      links: {
        about: 'About Us',
        careers: 'Careers',
        press: 'Press',
        shipping: 'Shipping Info',
        returns: 'Returns',
        contact: 'Contact Us',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
      },
    },
    home: {
      heroBadge: 'New Season Collection',
      heroTitle: 'GEAR UP FOR THE SEASON',
      heroSubtitle: 'Official replica kits for national teams and league clubs. Customize your favorite with your name and number.',
      shopTeams: 'Shop Teams',
      viewCustom: 'View Custom',
      representNation: 'REPRESENT YOUR NATION',
      viewAllTeams: 'View All Teams →',
      trending: 'TRENDING KITS',
      noProducts: 'No products available.',
    },
    teams: {
      title: 'Browse Teams',
      subtitle: 'Official kits from national teams and league clubs.',
      sortBy: 'Sort by:',
      sortFeatured: 'Featured',
      sortPriceAsc: 'Price: Low to High',
      sortPriceDesc: 'Price: High to Low',
      searchPlaceholder: 'Search teams or kits…',
      searchAria: 'Search teams or kits',
      filters: 'Filters',
      nationalTeams: 'National Teams',
      group: 'Group',
      jerseyType: 'Jersey Type',
      groupPrefix: 'Gr',
      typeHome: 'Home Kit',
      typeAway: 'Away Kit',
      typeThird: 'Third Kit',
      typeSpecial: 'Special',
      noMatch: 'No kits match your filters.',
      clearFilters: 'Clear filters',
      loadFailed: 'Failed to load kits.',
      quickAdd: 'Quick Add',
      badgeNew: 'NEW ARRIVAL',
      badgeWorldCup: 'WORLD CUP EDITION',
      defaultSubtitle: 'Authentic Match Jersey',
    },
    products: {
      titleAll: 'All Kits',
      titleTeam: '{team} Kits',
      countOne: '{n} product',
      countMany: '{n} products',
      loading: 'Loading…',
      searchPlaceholder: 'Search products or teams…',
      searchAria: 'Search products or teams',
      filters: 'Filters',
      kitType: 'Kit Type',
      allTypes: 'All Types',
      size: 'Size',
      priceRange: 'Price Range',
      clearFilters: 'Clear Filters',
      noMatch: 'No products match your filters.',
      loadFailed: 'Failed to load products.',
      view: 'View & Customize',
      badgeNew: 'NEW',
      badgeSale: 'SALE',
    },
    common: {
      loading: 'Loading...',
      logoutSuccess: 'You have been logged out.',
    },
    auth: {
      signIn: 'Sign In',
      createAccount: 'Create Account',
      welcomeBack: 'Welcome Back',
      createYourAccount: 'Create Your Account',
      termsBy: 'By continuing, you agree to our ',
      termsAnd: ' and ',
      termsEnd: '.',
      welcomeToast: 'Welcome back!',
      accountCreatedToast: 'Account created! Welcome to Ballers!',
      emailLabel: 'Email address',
      emailPlaceholder: 'you@example.com',
      passwordLabel: 'Password',
      passwordPlaceholder: '••••••••',
      registerPasswordPlaceholder: 'Min. 6 characters',
      fullNameLabel: 'Full name',
      fullNamePlaceholder: 'John Doe',
      confirmPasswordLabel: 'Confirm password',
      confirmPasswordPlaceholder: 'Re-enter your password',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      showConfirmPassword: 'Show confirm password',
      hideConfirmPassword: 'Hide confirm password',
      signingIn: 'Signing in...',
      creatingAccount: 'Creating account...',
      loginButton: 'Login',
      newHere: 'New here?',
      alreadyHaveAccount: 'Already have an account?',
      loginFailed: 'Login failed. Please check your credentials.',
      registrationFailed: 'Registration failed. Please try again.',
      strengthWeak: 'Weak',
      strengthFair: 'Fair',
      strengthGood: 'Good',
      strengthStrong: 'Strong',
      validationEmail: 'Please enter a valid email address',
      validationEmailRequired: 'Email is required',
      validationPasswordRequired: 'Password is required',
      validationPasswordMin: 'Password must be at least 6 characters',
      validationPasswordMax: 'Password must be less than 100 characters',
      validationNameRequired: 'Full name is required',
      validationNameMin: 'Name must be at least 2 characters',
      validationNameMax: 'Name must be less than 50 characters',
      validationConfirmRequired: 'Please confirm your password',
      validationPasswordsMatch: 'Passwords do not match',
    },
    checkout: {
      backToCart: 'Back to Cart',
      title: 'Checkout',
      loading: 'Loading checkout...',
      orderSummary: 'Order Summary',
      emptyCart: 'Your cart is empty.',
      qty: 'Qty: {n}',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      free: 'Free',
      total: 'Total',
      sslSecure: 'SSL encrypted & secure checkout',
      freeReturns: 'Free returns within 30 days',
      contactInfo: 'Contact Info',
      firstName: 'First name',
      firstNamePlaceholder: 'John',
      lastName: 'Last name',
      lastNamePlaceholder: 'Doe',
      emailAddress: 'Email address',
      emailPlaceholder: 'you@example.com',
      phoneOptional: 'Phone (optional)',
      phonePlaceholder: '+972 50 123 4567',
      shippingAddress: 'Shipping Address',
      streetAddress: 'Street address',
      streetPlaceholder: 'HaSolelim',
      city: 'City',
      cityPlaceholder: 'Tel Aviv',
      zip: 'ZIP / Postal code',
      zipPlaceholder: '10001',
      country: 'Country',
      selectCountry: 'Select country...',
      countryIsrael: 'Israel',
      payment: 'Payment',
      paymentMethodAria: 'Payment method: Credit Card via {provider}',
      creditCard: 'Credit Card',
      redirectNotice: "You will be redirected to {provider}'s secure payment page to complete your purchase. Visa • Mastercard • Amex • Discover",
      securedBy: 'Secured by',
      redirecting: 'Redirecting...',
      continueToPayment: 'Continue to Payment',
      continueToPaymentAmount: 'Continue to Payment — {amount}',
      startFailed: 'Failed to start checkout. Please try again.',
      missingReference: 'Missing checkout reference. If you completed payment, please contact support.',
      confirmFailed: 'We could not confirm your payment. If you were charged, please contact support.',
      notConfirmedTitle: 'Payment Not Confirmed',
      reference: 'Reference:',
      tryAgain: 'Try Again',
      confirming: 'Confirming your payment…',
      dontClose: "Please don't close this window.",
      // Order success
      statusConfirmed: 'Confirmed',
      statusProcessing: 'Processing',
      statusShipped: 'Shipped',
      statusDelivered: 'Delivered',
      statusFailed: 'Payment Failed',
      pendingTitle: 'Payment Processing',
      pendingMessage: 'Your payment is being verified by our payment provider. This usually completes within a few minutes. You will receive a confirmation email once your payment is confirmed and your order is being prepared.',
      failedBannerTitle: 'Payment Issue Detected',
      failedBannerMessage: 'There was an issue confirming your payment. If you believe you were charged, please contact our support team with your payment reference:',
      successHeading: 'Order Received!',
      failedHeading: 'Payment Issue',
      successSubtitle: 'Thank you for your purchase. Your kit is on its way!',
      failedSubtitle: 'We encountered an issue with your payment. Please see details below.',
      loadingDetails: 'Loading order details...',
      loadError: 'Unable to load order details. Please check your email for a confirmation, or contact support with your order reference.',
      orderDetails: 'Order Details',
      orderId: 'Order ID',
      paymentRef: 'Payment Ref',
      paymentLabel: 'Payment',
      paymentMethod: 'Credit Card ({provider})',
      status: 'Status',
      totalCharged: 'Total Charged',
      shippingTo: 'Shipping to',
      supportPrefix: 'If you need assistance, please contact ',
      supportQuoteRef: ' and quote payment reference ',
      emailConfirmPrefix: 'A confirmation email will be sent to ',
      emailConfirmFallback: 'your email address',
      emailConfirmSuffix: '. Orders typically ship within 2–3 business days.',
      continueShopping: 'Continue Shopping',
      backToHome: 'Back to Home',
      valFirstNameRequired: 'First name is required',
      valFirstNameMax: 'First name is too long',
      valLastNameRequired: 'Last name is required',
      valLastNameMax: 'Last name is too long',
      valEmailRequired: 'Email is required',
      valEmailInvalid: 'Please enter a valid email address',
      valPhoneInvalid: 'Please enter a valid phone number',
      valAddressRequired: 'Address is required',
      valAddressMax: 'Address is too long',
      valCityRequired: 'City is required',
      valCityMax: 'City is too long',
      valZipRequired: 'ZIP / Postal code is required',
      valZipMax: 'ZIP code is too long',
      valCountryRequired: 'Country is required',
    },
    cart: {
      title: 'Your Cart',
      subtitle: 'Review your items before checkout.',
      emptyTitle: 'Your Cart is Empty',
      emptySubtitle: 'Add a kit to get started.',
      shopKits: 'Shop Kits',
      itemsAria: 'Cart items',
      itemAttributes: 'Size: {size} · Color: {color}',
      removeAria: 'Remove {name}',
      decreaseQty: 'Decrease quantity',
      increaseQty: 'Increase quantity',
      stepShipping: 'Shipping',
      stepPayment: 'Payment',
      continueShopping: 'Continue Shopping',
      shippingDetails: 'Shipping Details',
      email: 'Email Address',
      emailPlaceholder: 'fan@ballers.com',
      firstName: 'First Name',
      firstNamePlaceholder: 'Lionel',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Messi',
      streetAddress: 'Street Address',
      streetPlaceholder: '10 Stadium Way',
      orderSummary: 'Order Summary',
      subtotalItems: 'Subtotal ({count} items)',
      estShipping: 'Estimated Shipping',
      free: 'Free',
      total: 'Total',
      continueToPayment: 'Continue to Payment',
      secureCheckout: 'Secure Checkout',
      drawerTitle: 'Your Cart',
      drawerAria: 'Shopping cart',
      closeAria: 'Close cart',
      headerCountOne: '({count} item)',
      headerCountMany: '({count} items)',
      drawerEmpty: 'Your cart is empty',
      sizeLabel: 'Size: {size}',
      decreaseQtyOf: 'Decrease quantity of {name}',
      increaseQtyOf: 'Increase quantity of {name}',
      removeFromCartAria: 'Remove {name} from cart',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      proceedToCheckout: 'Proceed to Checkout',
      productFallback: 'Product',
    },
    product: {
      completeTheKit: 'Complete the Kit',
      noRelated: 'No related products yet.',
      breadcrumbAria: 'Breadcrumb',
      fallbackName: 'Product',
      loadError: 'Failed to load product.',
      backToShop: 'Back to Shop',
      imageAlt: '{name} - view {n}',
      viewImageAria: 'View image {n}',
      kitBadge: '{type} KIT',
      selectSize: 'Select Size',
      sizeGuide: 'Size Guide',
      selectSizeError: 'Please select a size',
      personalize: 'Personalize',
      personalizeHint: 'Add a name & number to make it your own (+$15)',
      namePlaceholder: 'Name',
      playerNameAria: 'Player name',
      numberPlaceholder: 'Number',
      playerNumberAria: 'Player number',
      adding: 'Adding...',
      addedToCart: 'Added to Cart',
      addToCartAmount: 'Add to Cart — {amount}',
      addToCartAria: 'Add to cart',
      addFailed: 'Failed to add to cart',
      freeShipping: 'Free shipping',
    },
    notFound: {
      title: '404',
      message: 'Page not found',
      goHome: 'Go Home',
    },
    update: {
      title: 'Update Available',
      message: 'A new version of {brand} is ready. Refresh to get the latest features and improvements.',
      dismiss: 'Dismiss update notification',
      refresh: 'Refresh Now',
      later: 'Later',
    },
  },
  he: {
    brand: {
      name: 'הבולרים 🪖',
      tagline: 'לבשו את המשחק',
    },
    nav: {
      shop: 'חנות',
      teams: 'נבחרות',
      customKits: 'מדים מותאמים',
      dashboard: 'לוח בקרה',
      signIn: 'התחברות',
      signOut: 'התנתקות',
      adminDashboard: 'ניהול',
      cartAria: 'עגלת קניות, {count} פריט',
      cartAriaPlural: 'עגלת קניות, {count} פריטים',
      userMenu: 'תפריט משתמש',
      toggleMenu: 'פתח/סגור תפריט ניווט',
      home: 'דף הבית',
      language: 'שפה',
      languageEnglish: 'English',
      languageHebrew: 'עברית',
    },
    footer: {
      rights: '© {year} {brand} – חנות הכדורגל. כל הזכויות שמורות.',
      company: 'החברה',
      support: 'תמיכה',
      newsletter: 'ניוזלטר',
      newsletterCopy: 'קבלו את המדים והמבצעים החדשים ישירות למייל.',
      newsletterPlaceholder: 'you@email.com',
      newsletterSubmit: 'הצטרפו',
      emailLabel: 'כתובת אימייל',
      tagline: 'מוצרי כדורגל רשמיים בעלי רישיון',
      links: {
        about: 'אודות',
        careers: 'דרושים',
        press: 'עיתונות',
        shipping: 'פרטי משלוח',
        returns: 'החזרות',
        contact: 'צרו קשר',
        privacy: 'מדיניות פרטיות',
        terms: 'תנאי שימוש',
      },
    },
    home: {
      heroBadge: 'קולקציית העונה החדשה',
      heroTitle: 'התכוננו לעונה',
      heroSubtitle: 'מדים רשמיים של נבחרות וקבוצות ליגה. התאימו את המדים האהובים עם השם והמספר שלכם.',
      shopTeams: 'לקנייה לפי נבחרת',
      viewCustom: 'מותאם אישית',
      representNation: 'ייצגו את הנבחרת שלכם',
      viewAllTeams: 'לכל הנבחרות →',
      trending: 'המדים הכי חמים',
      noProducts: 'אין מוצרים להצגה.',
    },
    teams: {
      title: 'עיון בנבחרות',
      subtitle: 'מדים רשמיים של נבחרות וקבוצות ליגה.',
      sortBy: 'מיון לפי:',
      sortFeatured: 'מומלצים',
      sortPriceAsc: 'מחיר: נמוך לגבוה',
      sortPriceDesc: 'מחיר: גבוה לנמוך',
      searchPlaceholder: 'חיפוש נבחרת או מדים…',
      searchAria: 'חיפוש נבחרת או מדים',
      filters: 'סינון',
      nationalTeams: 'נבחרות',
      group: 'בית',
      jerseyType: 'סוג חולצה',
      groupPrefix: 'בית',
      typeHome: 'מדי בית',
      typeAway: 'מדי חוץ',
      typeThird: 'מדי שלישי',
      typeSpecial: 'מיוחד',
      noMatch: 'אין מדים שתואמים לסינון.',
      clearFilters: 'איפוס סינון',
      loadFailed: 'טעינת המדים נכשלה.',
      quickAdd: 'הוספה מהירה',
      badgeNew: 'חדש בקטלוג',
      badgeWorldCup: 'מהדורת מונדיאל',
      defaultSubtitle: 'חולצת משחק רשמית',
    },
    products: {
      titleAll: 'כל המדים',
      titleTeam: 'מדי {team}',
      countOne: 'מוצר {n}',
      countMany: '{n} מוצרים',
      loading: 'טוען…',
      searchPlaceholder: 'חיפוש מוצרים או נבחרות…',
      searchAria: 'חיפוש מוצרים או נבחרות',
      filters: 'סינון',
      kitType: 'סוג מדים',
      allTypes: 'כל הסוגים',
      size: 'מידה',
      priceRange: 'טווח מחירים',
      clearFilters: 'איפוס סינון',
      noMatch: 'אין מוצרים שתואמים לסינון.',
      loadFailed: 'טעינת המוצרים נכשלה.',
      view: 'צפייה והתאמה',
      badgeNew: 'חדש',
      badgeSale: 'מבצע',
    },
    common: {
      loading: 'טוען...',
      logoutSuccess: 'התנתקת מהחשבון.',
    },
    auth: {
      signIn: 'התחברות',
      createAccount: 'יצירת חשבון',
      welcomeBack: 'ברוכים השבים',
      createYourAccount: 'יצירת החשבון שלכם',
      termsBy: 'בהמשך אתם מסכימים ל',
      termsAnd: ' ול',
      termsEnd: '.',
      welcomeToast: 'ברוכים השבים!',
      accountCreatedToast: 'החשבון נוצר! ברוכים הבאים להבולרים!',
      emailLabel: 'כתובת אימייל',
      emailPlaceholder: 'you@example.com',
      passwordLabel: 'סיסמה',
      passwordPlaceholder: '••••••••',
      registerPasswordPlaceholder: 'לפחות 6 תווים',
      fullNameLabel: 'שם מלא',
      fullNamePlaceholder: 'ישראל ישראלי',
      confirmPasswordLabel: 'אימות סיסמה',
      confirmPasswordPlaceholder: 'הזינו שוב את הסיסמה',
      showPassword: 'הצגת סיסמה',
      hidePassword: 'הסתרת סיסמה',
      showConfirmPassword: 'הצגת אימות סיסמה',
      hideConfirmPassword: 'הסתרת אימות סיסמה',
      signingIn: 'מתחבר...',
      creatingAccount: 'יוצר חשבון...',
      loginButton: 'התחברות',
      newHere: 'חדשים כאן?',
      alreadyHaveAccount: 'כבר יש לכם חשבון?',
      loginFailed: 'ההתחברות נכשלה. בדקו את פרטי ההתחברות.',
      registrationFailed: 'ההרשמה נכשלה. נסו שוב.',
      strengthWeak: 'חלשה',
      strengthFair: 'בינונית',
      strengthGood: 'טובה',
      strengthStrong: 'חזקה',
      validationEmail: 'נא להזין כתובת אימייל תקינה',
      validationEmailRequired: 'יש להזין אימייל',
      validationPasswordRequired: 'יש להזין סיסמה',
      validationPasswordMin: 'הסיסמה חייבת להכיל לפחות 6 תווים',
      validationPasswordMax: 'הסיסמה חייבת להיות קצרה מ-100 תווים',
      validationNameRequired: 'יש להזין שם מלא',
      validationNameMin: 'השם חייב להכיל לפחות 2 תווים',
      validationNameMax: 'השם חייב להיות קצר מ-50 תווים',
      validationConfirmRequired: 'נא לאמת את הסיסמה',
      validationPasswordsMatch: 'הסיסמאות אינן תואמות',
    },
    checkout: {
      backToCart: 'חזרה לעגלה',
      title: 'תשלום',
      loading: 'טוען תשלום...',
      orderSummary: 'סיכום הזמנה',
      emptyCart: 'העגלה שלכם ריקה.',
      qty: 'כמות: {n}',
      subtotal: 'סכום ביניים',
      shipping: 'משלוח',
      free: 'חינם',
      total: 'סה״כ',
      sslSecure: 'תשלום מאובטח ומוצפן ב-SSL',
      freeReturns: 'החזרות חינם תוך 30 יום',
      contactInfo: 'פרטי קשר',
      firstName: 'שם פרטי',
      firstNamePlaceholder: 'ישראל',
      lastName: 'שם משפחה',
      lastNamePlaceholder: 'ישראלי',
      emailAddress: 'כתובת אימייל',
      emailPlaceholder: 'you@example.com',
      phoneOptional: 'טלפון (לא חובה)',
      phonePlaceholder: '050-123-4567',
      shippingAddress: 'כתובת למשלוח',
      streetAddress: 'רחוב ומספר',
      streetPlaceholder: 'הסוללים',
      city: 'עיר',
      cityPlaceholder: 'תל אביב',
      zip: 'מיקוד',
      zipPlaceholder: '10001',
      country: 'מדינה',
      selectCountry: 'בחרו מדינה...',
      countryIsrael: 'ישראל',
      payment: 'תשלום',
      paymentMethodAria: 'אמצעי תשלום: כרטיס אשראי דרך {provider}',
      creditCard: 'כרטיס אשראי',
      redirectNotice: 'תועברו לעמוד התשלום המאובטח של {provider} להשלמת הרכישה. ויזה • מאסטרקארד • אמקס • דיסקבר',
      securedBy: 'מאובטח על ידי',
      redirecting: 'מעביר...',
      continueToPayment: 'המשך לתשלום',
      continueToPaymentAmount: 'המשך לתשלום — {amount}',
      startFailed: 'פתיחת התשלום נכשלה. נסו שוב.',
      missingReference: 'חסר מזהה תשלום. אם השלמתם תשלום, פנו לתמיכה.',
      confirmFailed: 'לא הצלחנו לאמת את התשלום. אם חויבתם, פנו לתמיכה.',
      notConfirmedTitle: 'התשלום לא אומת',
      reference: 'מזהה:',
      tryAgain: 'נסו שוב',
      confirming: 'מאמת את התשלום…',
      dontClose: 'אנא אל תסגרו את החלון.',
      // Order success
      statusConfirmed: 'אושר',
      statusProcessing: 'בעיבוד',
      statusShipped: 'נשלח',
      statusDelivered: 'נמסר',
      statusFailed: 'התשלום נכשל',
      pendingTitle: 'התשלום בעיבוד',
      pendingMessage: 'התשלום שלכם מאומת על ידי ספק התשלומים. תהליך זה מסתיים בדרך כלל תוך מספר דקות. תקבלו אימייל אישור ברגע שהתשלום יאושר וההזמנה תיכנס להכנה.',
      failedBannerTitle: 'זוהתה בעיה בתשלום',
      failedBannerMessage: 'אירעה בעיה באימות התשלום. אם נראה לכם שחויבתם, פנו לצוות התמיכה עם מזהה התשלום:',
      successHeading: 'ההזמנה התקבלה!',
      failedHeading: 'בעיה בתשלום',
      successSubtitle: 'תודה על הרכישה. המדים שלכם בדרך אליכם!',
      failedSubtitle: 'נתקלנו בבעיה בתשלום שלכם. ראו פרטים למטה.',
      loadingDetails: 'טוען פרטי הזמנה...',
      loadError: 'לא ניתן לטעון את פרטי ההזמנה. בדקו את האימייל לאישור, או פנו לתמיכה עם מזהה ההזמנה.',
      orderDetails: 'פרטי הזמנה',
      orderId: 'מספר הזמנה',
      paymentRef: 'מזהה תשלום',
      paymentLabel: 'תשלום',
      paymentMethod: 'כרטיס אשראי ({provider})',
      status: 'סטטוס',
      totalCharged: 'סה״כ חויב',
      shippingTo: 'נשלח אל',
      supportPrefix: 'אם אתם זקוקים לעזרה, פנו אל ',
      supportQuoteRef: ' וציינו את מזהה התשלום ',
      emailConfirmPrefix: 'אימייל אישור יישלח אל ',
      emailConfirmFallback: 'כתובת האימייל שלכם',
      emailConfirmSuffix: '. הזמנות נשלחות בדרך כלל תוך 2–3 ימי עסקים.',
      continueShopping: 'המשך בקנייה',
      backToHome: 'חזרה לדף הבית',
      valFirstNameRequired: 'יש להזין שם פרטי',
      valFirstNameMax: 'השם הפרטי ארוך מדי',
      valLastNameRequired: 'יש להזין שם משפחה',
      valLastNameMax: 'שם המשפחה ארוך מדי',
      valEmailRequired: 'יש להזין אימייל',
      valEmailInvalid: 'נא להזין כתובת אימייל תקינה',
      valPhoneInvalid: 'נא להזין מספר טלפון תקין',
      valAddressRequired: 'יש להזין כתובת',
      valAddressMax: 'הכתובת ארוכה מדי',
      valCityRequired: 'יש להזין עיר',
      valCityMax: 'שם העיר ארוך מדי',
      valZipRequired: 'יש להזין מיקוד',
      valZipMax: 'המיקוד ארוך מדי',
      valCountryRequired: 'יש לבחור מדינה',
    },
    cart: {
      title: 'העגלה שלך',
      subtitle: 'בדקו את הפריטים לפני התשלום.',
      emptyTitle: 'העגלה שלך ריקה',
      emptySubtitle: 'הוסיפו חולצה כדי להתחיל.',
      shopKits: 'לחנות החולצות',
      itemsAria: 'פריטים בעגלה',
      itemAttributes: 'מידה: {size} · צבע: {color}',
      removeAria: 'הסרת {name}',
      decreaseQty: 'הפחתת כמות',
      increaseQty: 'הגדלת כמות',
      stepShipping: 'משלוח',
      stepPayment: 'תשלום',
      continueShopping: 'המשך בקנייה',
      shippingDetails: 'פרטי משלוח',
      email: 'כתובת אימייל',
      emailPlaceholder: 'fan@ballers.com',
      firstName: 'שם פרטי',
      firstNamePlaceholder: 'ליונל',
      lastName: 'שם משפחה',
      lastNamePlaceholder: 'מסי',
      streetAddress: 'כתובת',
      streetPlaceholder: 'רחוב האצטדיון 10',
      orderSummary: 'סיכום הזמנה',
      subtotalItems: 'סכום ביניים ({count} פריטים)',
      estShipping: 'משלוח משוער',
      free: 'חינם',
      total: 'סה״כ',
      continueToPayment: 'המשך לתשלום',
      secureCheckout: 'תשלום מאובטח',
      drawerTitle: 'העגלה שלך',
      drawerAria: 'עגלת קניות',
      closeAria: 'סגירת העגלה',
      headerCountOne: '(פריט {count})',
      headerCountMany: '({count} פריטים)',
      drawerEmpty: 'העגלה שלך ריקה',
      sizeLabel: 'מידה: {size}',
      decreaseQtyOf: 'הפחתת כמות של {name}',
      increaseQtyOf: 'הגדלת כמות של {name}',
      removeFromCartAria: 'הסרת {name} מהעגלה',
      subtotal: 'סכום ביניים',
      shipping: 'משלוח',
      proceedToCheckout: 'המשך לתשלום',
      productFallback: 'מוצר',
    },
    product: {
      completeTheKit: 'השלימו את הערכה',
      noRelated: 'אין עדיין מוצרים קשורים.',
      breadcrumbAria: 'ניווט',
      fallbackName: 'מוצר',
      loadError: 'טעינת המוצר נכשלה.',
      backToShop: 'חזרה לחנות',
      imageAlt: '{name} - תצוגה {n}',
      viewImageAria: 'הצגת תמונה {n}',
      kitBadge: 'ערכת {type}',
      selectSize: 'בחירת מידה',
      sizeGuide: 'מדריך מידות',
      selectSizeError: 'יש לבחור מידה',
      personalize: 'התאמה אישית',
      personalizeHint: 'הוסיפו שם ומספר כדי להפוך אותה לשלכם (15$+)',
      namePlaceholder: 'שם',
      playerNameAria: 'שם השחקן',
      numberPlaceholder: 'מספר',
      playerNumberAria: 'מספר השחקן',
      adding: 'מוסיף...',
      addedToCart: 'נוסף לעגלה',
      addToCartAmount: 'הוספה לעגלה — {amount}',
      addToCartAria: 'הוספה לעגלה',
      addFailed: 'הוספה לעגלה נכשלה',
      freeShipping: 'משלוח חינם',
    },
    notFound: {
      title: '404',
      message: 'הדף לא נמצא',
      goHome: 'חזרה לדף הבית',
    },
    update: {
      title: 'עדכון זמין',
      message: 'גרסה חדשה של {brand} מוכנה. רעננו את הדף כדי לקבל את התכונות והשיפורים האחרונים.',
      dismiss: 'סגירת הודעת עדכון',
      refresh: 'רענון עכשיו',
      later: 'אחר כך',
    },
  },
};

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'he', label: 'עברית', dir: 'rtl' },
];

export const DEFAULT_LANGUAGE = 'he';
